var initial_load = true;

$(document).ready(function() {
    if ($('.filter-sidebar.books').length > 0) {

        // Mark as checked the first input
        $('.checkbox-terms').prop('checked', false);
        $('.checkbox-terms').removeClass('checked').attr('checked', false);
        $('.checkbox-terms').eq(0).prop('checked', true);
        $('.spinner').addClass('loading');

        doFilterBooks();

        $('.checkbox-terms').change(function() {
            // Remove checked state for every other input
            $('.checkbox-terms').prop('checked', false);
            $('.checkbox-terms').removeClass('checked').attr('checked', false);

            // Check the current input
            $(this).prop('checked', true);

            
            $('.results-title .category ').html($(this).attr('data-category'));
            $('.results-title .subcategory').html($(this).attr('data-subcategory'));

            $('#paged').val('1');
            doFilterBooks();
        });

        $('.filters-sort-books').change(function() {
            $('#paged').val('1');
            doFilterBooks();
        });

        $('.button-load-more-books').click(function () {
            var paged = parseInt($('#paged').val()) + 1;
            $('#paged').val(paged);
 
            // Load more Books 
            doFilterBooks();
        });

        $('.button-load-more-books').click(function () {
            var paged = parseInt($('#paged').val()) + 1;
            $('#paged').val(paged);
 
            // Load more Books 
            doFilterBooks();
        });

        // Pagination
        $(document).on('click', '.results-container__pagination a.page-numbers', function(){
            if (!jQuery(this).hasClass('disabled')) {
                if (jQuery(this).text() > 0) {
                    jQuery('#paged').val(jQuery(this).text());
                } else if (jQuery(this).hasClass('prev')) {
                    jQuery('#paged').val((jQuery('#paged').val()*1)-1);
                } else if (jQuery(this).hasClass('next')) {
                    jQuery('#paged').val((jQuery('#paged').val()*1)+1);
                }
            }
            
            doFilterBooks();
        });
    }
});

function doFilterBooks() {

    // Hide pagination 
    $('.results-container__pagination').html('');

    // Show loading
    $('.spinner').addClass('loading');

    // Remove all previous posts, we're doing a traditional pagination
    $('.results-container__posts').empty();

    // Build URL Parameters
    // buildURLParameters(terms, $('input[name=date-range]:checked').val(), date_range, orderby);

    // Do a scroll to top
    if (!isFirstLoad()) { // I only want to auto scroll if it's not the first page load 
        jQuery('html, body').animate({
            scrollTop: jQuery('.results-title').offset().top - 50
        }, 800);
    } else {
        updateFirstLoad();
    }

    // AJAX call
    $.ajax({
        url: ajax_var.url,
        method: 'POST',
        data: {
            action: 'taoti_archive_query_books_more',
            category: $('.checkbox-terms:checked').val(),
            paged: $('#paged').val(),
            orderby: $('.filters-sort-books').val()
        }, success: function (response) {

            if (response && response.success) {
                // Add new content
                if (response.data.count > 0) {

                    // Scroll To last post row if page is not the first one
                    if ($('#paged').val() != 1) {
                        $('html, body').animate({scrollTop: $('.results-container__loader').offset().top}, 'slow');
                    }

                    $('.results-container__posts').append(response.data.html);
                } else {
                    $('.results-container__posts').html('No results found');
                    $('.results-found-qty').html('0 results showing');
                }

                

                // Hide loading
                $('.spinner').removeClass('loading');

                // Check if I need to show again the pagination
                if (response.data.see_more) {
					$('.results-container__pagination').html(response.data.pagination);
                    modifyPaginationLinks();
                }
            }
        }, error: function (error) {
            console.log(error);

            // Hide loading
            $('.spinner').removeClass('loading');
        }
    });

    
}

function modifyPaginationLinks() {
    // Modify href of each pagination link to perform a JS call
    jQuery('.results-container__pagination a.page-numbers').each(function() {
        if (!jQuery(this).hasClass('disabled')) {
                jQuery(this).attr('href', 'javascript: void(0);')
        }
    });
}

function isFirstLoad() {
    return initial_load;
}

function updateFirstLoad() {
    initial_load = false;
}